<template>
  <header class="head">
    <h3 class="title">{{title}}</h3>
    <p class="sub-title">（{{subTitle | coverPhone}}）</p>
    <span class="date" v-if="date">{{date}}</span>
  </header>
</template>

<script>
  export default {
    props: {
      date: {
        type: String
      }
    },
    data() {
      return {
        title: '',
        subTitle: ''
      }
    },
    mounted() {
      try {
        const { dealer_name, phone } = JSON.parse(localStorage.getItem('userInfo'))
        this.title = dealer_name // eslint-disable-line
        this.subTitle = phone
      } catch (e) {
        console.error(e)
      }
    }
  }
</script>

<style scoped lang="less">
  .head {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    width: 100%;
    height: 5.2rem;
    padding-top: 0.6rem;
    background: #2f333b;
    &:after {
      position: absolute;
      left: 50%;
      top: 5.2rem;
      margin-left: -5rem;
      content: '';
      width: 0;
      height: 0;
      border-top: 1.5rem solid #2f333b;
      border-bottom: 1.5rem solid transparent;
      border-left: 5rem solid transparent;
      border-right: 5rem solid transparent;
    }

    .title {
      text-align: center;
      font-size: 22px;
      color: #ffffff;
    }

    .sub-title {
      text-align: center;
      font-size: 14px;
      color: #ffffff;
    }

    .date {
      width: 3rem;
      height: 0.7rem;
      line-height: 0.7rem;
      margin-top: .4rem;
      text-align: center;
      background-color: #ff8743;
      border-radius: 0.3rem;
      font-size: 16px;
      color: #ffffff;
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?6bf26844